export const validateDynamicVariable = (variable?: string | null) => {
  const isDynamic: boolean = !!variable;
  const hasDynamicVariable: boolean = isDynamic && !!variable?.startsWith("{{");
  const dynamicVariableParsed: boolean =
    isDynamic && !variable?.startsWith("{{");

  return { isDynamic, hasDynamicVariable, dynamicVariableParsed } as const;
};
